import React from 'react';
import coding from '../../assets/images/coding.gif';
const MyProfessionField = ({ myProfessionField }) => {
    const { fieldName, fieldDescription } = myProfessionField;
    return (
        <div className='relative border-[1px]  border-[#02162b]  rounded md:rounded-md shadow-lg shadow-black overflow-hidden' >
            <img className='w-full h-44 sm:h-36 md:h-52 xl:h-44 2xl:h-56 opacity-20 overflow-hidden' style={{ filter: 'blur(3px)' }} src={coding} alt="" />
            <div data-aos="fade" data-aos-duration="1500" className='absolute top-0 left-0 py-3 px-4'>
                <span className='text-green-500 font-Cormorant-Garamond text-xl sm:text-2xl font-semibold'>{fieldName}</span>
                <p className='text-sm md:text-md lg:text-lg leading-5 md:leading-6 font-Cormorant-Garamond mt-2 xs:mt-0' > {`${fieldDescription}`} </p>
            </div>
        </div>
    );
};

export default MyProfessionField;